import React, { Component } from 'react';
import { Row, Col, FormControl, InputGroup, Button } from 'react-bootstrap';

export default class Search extends Component {
  constructor(props){
    super(props);
    this.state = {
      search_value:null,
    };
  }

  setSearchValue = (event) => {
    this.setState({search_value: event.target.value});
  }

  doSearch = () => {
    if(this.state.search_value != null){
      this.props.history.push(`/search/${this.state.search_value}`);
    }
  }

  pressEnter = (target) => {
    if(target.charCode === 13 && this.state.search_value != null){
      this.props.history.push(`/search/${this.state.search_value}`);
    } 
  }

  render() {
    return (
      <Row className="search-bar">
        <Col xl={12}>
          <InputGroup size="lg">
              <FormControl
                type="text"
                placeholder="Transaction Id"
                onChange={this.setSearchValue}
                onKeyPress={this.pressEnter}
              />
              <InputGroup.Append>
                <Button 
                  variant="success" 
                  disabled={false}
                  onClick={this.doSearch}
                  >
                  <i className="fas fa-search"></i> Search
                </Button>
              </InputGroup.Append>
            </InputGroup>
        </Col>
      </Row>
    )
  }
}


